import { getOperationName } from 'apollo-utilities';
import { gql, useMutation } from '@apollo/client';
import {
  SAMPLE_REQUEST_CONTEXT_QUERY,
  SAMPLE_REQUEST_FRAGMENT,
} from '@/contexts/ads-context-queries';
import {
  SampleRequest_FollowUpSubmitMutation,
  SampleRequest_FollowUpSubmitMutationVariables,
} from '@/types';

export const SUBMIT_SAMPLE_REQUEST_FOLLOW_UP_MUTATION = gql`
  mutation SampleRequest_FollowUpSubmit(
    $followUpResponse: FollowUpResponse
    $restaurantUUID: uuid!
    $sampleRequestUUID: uuid!
    $supplierUUID: uuid!
  ) {
    submitSampleRequestFollowUp(
      follow_up_response: $followUpResponse
      restaurant_id: $restaurantUUID
      sample_request_id: $sampleRequestUUID
      supplier_id: $supplierUUID
    ) {
      sample_request {
        ...SampleRequestFields
      }
    }
  }

  ${SAMPLE_REQUEST_FRAGMENT}
`;

export const useSubmitSampleRequestFollowUp = () => {
  const [submitSampleRequestFollowUp] = useMutation<
    SampleRequest_FollowUpSubmitMutation,
    SampleRequest_FollowUpSubmitMutationVariables
  >(SUBMIT_SAMPLE_REQUEST_FOLLOW_UP_MUTATION, {
    awaitRefetchQueries: true,
    refetchQueries: [getOperationName(SAMPLE_REQUEST_CONTEXT_QUERY) as string],
  });
  return {
    submitSampleRequestFollowUp,
  };
};
